import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});
const instance3 = axios.create({
  baseURL: apihostname,
});
// const head = { "Content-Type": "multipart/form-data" };

// const instance2 = axios.create({
//   baseURL: "http://localhost:3333",
//   headers: { ...authHeader(), ...head },
// });
class FarmermasterService {
  // newPass(id, req) {
  //   return instance.put("/users/new", req, {
  //     params: {
  //       id: id,
  //     },
  //   });
  // }
  //   updateUserprofile(id, req) {
  //     return instance.put("/users/profile/" + id, req);
  //   }
  //   getUserprofile(id) {
  //     return instance.get("/users/profile/" + id);
  //   }
  // deleteFarmermaster(id) {
  //   return instance.delete("/timereg/" + id);
  // }
  // getFarmermasterlist(body) {
  //   return instance.get("/farmermaster/list");
  // }
  // createFarmermaster(userid, body) {
  //   return instance.post("/timereg/new", body, {
  //     user: {
  //       user_id: userid,
  //     },
  //   });
  // }
  getRegsugarIsFarmerMaster(person_card) {
    return instance.get("/regsugarcane-is-masterfarmer/" + person_card);
  }
  checkFarmerMaster(body) {
    return instance.post("/check_master", body);
  }
  searchFarmerMaster(body) {
    return instance.post("/listfarmer-master-search", body);
  }
  updateStatusMaster(body) {
    return instance.put("/regsugar/update-status-master", body);
  }
  getFarmerMaster(reg_id, timereg_id) {
    return instance.get("/farmer-masterlist/" + reg_id + "/" + timereg_id);
  }
  getFarmerMasterForRegistrar(reg_id, timereg_id) {
    return instance.get(
      "/farmer-masterlist-for-registrar/" + reg_id + "/" + timereg_id
    );
  }
  getFarmerByPersonCard(person_card) {
    return instance.get("/farmer-master-bycard/" + person_card);
  }
  registerFarmerMaster(body) {
    return instance.post("/register_master", body);
  }
  EditregisterFarmerMaster(body) {
    return instance.post("/edit_register_master", body);
  }
  deleteFarmerMaster(body) {
    return instance.post("/delete_master", body);
  }
  getMasterAssocMember(master_id) {
    return instance.get("/master_assoc_member/" + master_id);
  }
  getMasterDirect(master_id) {
    return instance.get("/master_direct/" + master_id);
  }
  getMasterUnder(master_id) {
    return instance.get("/master_under/" + master_id);
  }
  getMasterDeed(master_id) {
    return instance.get("/master_deed/" + master_id);
  }
  getMasterPrintPdf(master_id) {
    return instance.get("/farmer-master-print/" + master_id);
  }
  checkRegsugarcaneMaster(idcard) {
    return instance3.get("/check-regsugarcane-master/" + idcard);
  }
}

export default new FarmermasterService();
